import equipeImg from "@/assets/images/fotoequipe.png"

import tempoIcon from "@/assets/icons/time.png"
import ideiaIcon from "@/assets/icons/ideia.png"

export const foto = equipeImg

export const titles = {
  pt: {
    first: "Sobre",
    second: "Nós"
  },
  en: {
    first: "About",
    second: "Us"
  }
}
export const sobre = {
  pt: [
    {
      icon: tempoIcon,
      alt: "Tempo",
      title: "Fundada em 2020",
      subtitle: "Por dois amigos de faculdade",
      paragraphs: [
        "A Black Paladins nasceu da paixão de dois estudantes de Jogos Digitais que compartilhavam o mesmo sonho: criar experiências interativas que marcassem a vida dos jogadores.",
        "Somos um estúdio independente de desenvolvimento de jogos digitais, especializado na criação de experiências autorais que unem criatividade, qualidade técnica e identidade cultural. Desenvolvemos projetos próprios com identidade marcante, explorando narrativa, design e inovação como formas de expressão interativa."
      ]
    },
    {
      icon: ideiaIcon,
      alt: "Ideia",
      title: "Nossa Missão",
      subtitle: "Inovação e qualidade",
      paragraphs: [
        "Desenvolvemos jogos digitais autorais que proporcionam experiências significativas, acessíveis e criativas, contribuindo para o fortalecimento da indústria independente.",
        "Além disso, oferecemos nossos serviços para empresas e indivíduos que desejam dar vida aos seus projetos, atuando também em demandas terceirizadas e oferecendo suporte em diferentes etapas do desenvolvimento, sempre com profissionalismo e excelência."
      ]
    }
  ],

  en: [
    {
      icon: tempoIcon,
      alt: "Time",
      title: "Founded in 2020",
      subtitle: "By two college friends",
      paragraphs: [
        "Black Paladins was born from the passion of two Digital Games students who shared the same dream: creating interactive experiences that would impact players.",
        "We are an independent game development studio specialized in creating original experiences that combine creativity, technical quality and cultural identity. We develop our own projects with strong identity, exploring narrative, design and innovation as forms of interactive expression."
      ]
    },
    {
      icon: ideiaIcon,
      alt: "Idea",
      title: "Our Mission",
      subtitle: "Innovation and quality",
      paragraphs: [
        "We develop original digital games that provide meaningful, accessible and creative experiences, contributing to the growth of the independent industry.",
        "In addition, we offer our services to companies and individuals who want to bring their projects to life, also working on outsourced demands and providing support in different stages of development."
      ]
    }
  ]
}